import React from "react"
import Back from "../common/back/Back"
import TeamCard from "./TeamCard"
import "./team.css"

const Team = () => {
  return (
    <>
      <Back title="Meet the Team" />

      {/* Intro banner */}
      <section className="team-intro">
        <div className="container">
          <div className="team-intro-inner">
            <p className="team-eyebrow">OUR TEAM</p>
            <h2>The Engine Behind Our Mission</h2>
            <p>
              At Rovers Access Limited, our team brings specialised expertise in trading,
              operations, technology, and growth. Together, we ensure that every student
              receives world-class education, seamless support, and a professional
              learning environment.
            </p>
          </div>
        </div>
      </section>

      {/* Team cards */}
      <section className="team padding">
        <div className="container">
          <TeamCard />
        </div>
      </section>
    </>
  )
}

export default Team
